import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IInvestMediaportalMarketQuotationsProps } from '../../../models';

import { InvestMediaportalMarketQuotationsDesktop as Component } from './component';

export const InvestMediaportalMarketQuotationsDesktop = createWidget<
    unknown,
    IInvestMediaportalMarketQuotationsProps
>({})(Component);
